/* unplugin-vue-components disabled */import script from "./WeixinMallPublishModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeixinMallPublishModal.vue?vue&type=script&setup=true&lang=ts"

import "./WeixinMallPublishModal.vue?vue&type=style&index=0&id=61d68a77&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d68a77"]])

export default __exports__